module.exports = __webpack_public_path__ + "static/adiat-4c9134d22f85808cefa330cd5227e28c.jpg";